export const glyphNames = [
    'acorn',
    'attachment',
    'bag',
    'barchart',
    'batch-download',
    'batch-upload',
    'bell',
    'book',
    'box-fill',
    'box',
    'cal-empty',
    'cal-full',
    'cart',
    'chat-bubble',
    'chat',
    'check-alt',
    'check-circle',
    'check',
    'circle',
    'compose',
    'computer',
    'creditcard',
    'dbl-left',
    'dbl-right',
    'disc-alt',
    'disc',
    'down',
    'download',
    'draft-in',
    'east',
    'educator',
    'error',
    'exclamation-circle',
    'exclamation',
    'expand-window',
    'facebook',
    'fax',
    'filter',
    'globe',
    'home',
    'instagram',
    'laptop',
    'left',
    'lightbulb',
    'linkedin',
    'list',
    'location',
    'lock',
    'mail',
    'matrix',
    'megaphone',
    'menu-local',
    'menu',
    'minus',
    'nav-links',
    'needs-score',
    'new-doc',
    'new-window',
    'no-draft',
    'north-east',
    'north-west',
    'note',
    'online-tool',
    'order-asc',
    'order-desc',
    'pending',
    'phone-alt',
    'phone',
    'play',
    'plus',
    'print',
    'question',
    'quote-left',
    'quote-right',
    'refresh',
    'resources',
    'right',
    'save-date',
    'search',
    'see-off',
    'see-on',
    'series',
    'settings',
    'share',
    'signed-in',
    'sort-asc',
    'sort-desc',
    'sort',
    'sound',
    'south-east',
    'south-west',
    'tag',
    'task-complete',
    'test-scored',
    'twitter',
    'up',
    'upload',
    'user',
    'west',
    'window',
    'x-mark',
    'youtube',
];
//# sourceMappingURL=GlyphName.js.map